import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const Unsubscribe = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <div className="container py-8">
        <Button
          variant="ghost"
          className="mb-4"
          onClick={() => navigate(-1)}
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back
        </Button>

        <div className="prose prose-sm md:prose-base lg:prose-lg dark:prose-invert max-w-none">
          <h1>Unsubscribe from Newsletter</h1>
          <p>To unsubscribe from our newsletter:</p>
          <ul>
            <li>Click the unsubscribe link in any newsletter email</li>
            <li>Or contact us at unsubscribe@example.com</li>
          </ul>

          <h2>What happens when you unsubscribe?</h2>
          <ul>
            <li>You'll be removed from our mailing list immediately</li>
            <li>You won't receive any future newsletters</li>
            <li>Your preferences will be saved if you choose to resubscribe</li>
          </ul>

          <h2>Need Help?</h2>
          <p>If you're having trouble unsubscribing or have any questions, please contact our support team.</p>
        </div>
      </div>
    </div>
  );
};

export default Unsubscribe;